import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '../ui/components/web/Dialog';
import NotificationsTab from '../../settings/components/web/NotificationsTab';
import { translate } from '../i18n/functions';
import { getNotificationsTabProps } from '../../settings/functions.any';
import { submitNotificationsTab } from '../../settings/actions.web';
class NotificationsDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabState: { ...props.notificatonTabProps }
        };
        this._onSubmitValue = this._onSubmitValue.bind(this);
        this._onChange = this._onChange.bind(this);
    }
    _onSubmitValue() {
        ;
        const { dispatch } = this.props;
        console.log(this.state.tabState);
        dispatch(submitNotificationsTab(this.state.tabState));
    }
    _onChange(tabStateUpdate) {
        this.setState(prevState => ({
            tabState: {
                ...prevState.tabState,
                ...tabStateUpdate // Spread the update object into the existing tabState
            }
        }));
    }
    render() {
        const { t, notificatonTabProps } = this.props;
        const updatedProps = {
            ...notificatonTabProps,
            onChange: this._onChange
        };
        return (React.createElement(Dialog, { disableAutoHideOnSubmit: false, ok: {
                translationKey: 'dialog.Ok'
            }, onSubmit: this._onSubmitValue, titleKey: 'profile.title' }, React.createElement(NotificationsTab, { ...updatedProps })));
    }
}
function _mapStateToProps(state, ownProps) {
    const configuredTabs = interfaceConfig.SETTINGS_SECTIONS || [];
    const showSoundsSettings = configuredTabs.includes('sounds');
    const notificatonTabPropsFromState = getNotificationsTabProps(state, showSoundsSettings);
    return {
        notificatonTabProps: {
            ...notificatonTabPropsFromState,
            soundsIncomingMessage: notificatonTabPropsFromState.soundsIncomingMessage ?? false, // Ensure boolean
            soundsParticipantJoined: notificatonTabPropsFromState.soundsParticipantJoined ?? false,
            soundsParticipantKnocking: notificatonTabPropsFromState.soundsParticipantKnocking ?? false,
            soundsParticipantLeft: notificatonTabPropsFromState.soundsParticipantLeft ?? false,
            soundsTalkWhileMuted: notificatonTabPropsFromState.soundsTalkWhileMuted ?? false,
            soundsReactions: notificatonTabPropsFromState.soundsReactions ?? false,
            enableReactions: notificatonTabPropsFromState.enableReactions ?? false,
            moderatorMutedSoundsReactions: notificatonTabPropsFromState.moderatorMutedSoundsReactions ?? false,
            showSoundsSettings: notificatonTabPropsFromState.showSoundsSettings ?? false,
        }
    };
}
;
export default translate(connect(_mapStateToProps)(NotificationsDialog));
